// Loop-prevention contract between the edge middleware and the markdown API
// route. The middleware rewrites any `Accept: text/markdown` request to
// `/api/markdown`; that route then fetches the page's HTML for conversion with
// this header set so the middleware skips the rewrite and serves real HTML
// instead of recursing. Both sides MUST agree on the exact string — keep it
// here so a rename can't silently desync them and reintroduce the recursion.
export const SKIP_MARKDOWN_HEADER = "x-skip-markdown"
export const SKIP_MARKDOWN_VALUE = "1"

// Compatibility bridge for middleware `NextResponse.rewrite` to Pages API:
// rewrite-added query params can be dropped before `/api/markdown` sees them
// (observed on Next.js 15.5.20 — see Linear MAR-47; `next.config.js` rewrite
// destinations still merge their query), so middleware also forwards the
// negotiated pathname as this request header. The API prefers the header and
// falls back to `?path=` — both still pass through normalizePath. Middleware
// authors the header from the URL on page `.md` alternates and the
// Accept-negotiation rewrite. It blanks inbound copies on the `/api` and
// `/_next` `.md` paths it leaves to the config rewrite's `?path=`.
export const MARKDOWN_PATH_HEADER = "x-markdown-path"

// Query key shared by the middleware rewrite and direct `/api/markdown` callers.
// `next.config.js` hardcodes the same string in the `.md` rewrite destination
// (`/api/markdown?path=/:slug`) — CommonJS can't import this TS const.
export const MARKDOWN_PATH_QUERY = "path"

// Meta name the Storyblok catch-all emits on every CMS page. `/api/markdown`
// looks for it in current HTML: CMS pages convert that HTML instead of trusting
// a committed snapshot, so testimonial bloks stay in step with the page.
export const STORYBLOK_PAGE_MARKER = "odin-storyblok"

// Shared by middleware (which `.md` paths get a URL-authored path bridge) and
// /api/markdown (which paths it accepts), so the two layers cannot drift.
// A page alternate ends in `.md`, optionally followed by trailing slashes.
export const MARKDOWN_ALTERNATE_SUFFIX = /\.md\/*$/i
// Internal routes the Markdown surface never converts, in any letter case.
export const MARKDOWN_NON_PAGE_PATH = /^\/(?:api|_next)(?:\/|$)/i
